import bootstrap from 'bootstrap/dist/js/bootstrap.bundle'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.provide('bootstrap', bootstrap)
})
